import React from 'react';
import styled from 'styled-components';

interface PriceFilterProps {
  selectedPrices: string[];
  onChange: (prices: string[]) => void;
}

const PriceFilter: React.FC<PriceFilterProps> = ({ selectedPrices, onChange }) => {
  const priceOptions = [
    { value: '1', label: '$', tooltip: 'Inexpensive' },
    { value: '2', label: '$$', tooltip: 'Moderate' },
    { value: '3', label: '$$$', tooltip: 'Expensive' },
    { value: '4', label: '$$$$', tooltip: 'Very Expensive' },
  ];

  const togglePrice = (value: string) => {
    const currentSelection = [...selectedPrices];
    const index = currentSelection.indexOf(value);
    
    if (index > -1) {
      // Remove if already selected
      currentSelection.splice(index, 1);
    } else {
      // Add if not selected
      currentSelection.push(value);
    }
    
    onChange(currentSelection);
  };

  return (
    <FilterContainer>
      <FilterTitle>Price Range</FilterTitle>
      <ButtonsContainer>
        {priceOptions.map((option) => (
          <PriceButton 
            key={option.value}
            isSelected={selectedPrices.includes(option.value)}
            onClick={() => togglePrice(option.value)}
            title={option.tooltip}
          >
            {option.label}
          </PriceButton>
        ))}
      </ButtonsContainer>
    </FilterContainer>
  );
};

const FilterContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const FilterTitle = styled.h3`
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
  color: var(--text-color);
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const PriceButton = styled.button<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.isSelected ? 'var(--primary-color)' : 'var(--card-bg)'};
  color: ${props => props.isSelected ? 'white' : 'var(--text-color)'};
  border: 1px solid ${props => props.isSelected ? 'var(--primary-color)' : '#ddd'};
  border-radius: 8px;
  padding: 0.5rem;
  min-width: 3rem;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.2s;
  box-shadow: ${props => props.isSelected ? '0 2px 8px rgba(255, 90, 95, 0.25)' : 'none'};
  
  &:hover {
    background: ${props => props.isSelected ? 'var(--primary-color)' : '#e8e8e8'};
    transform: translateY(-2px);
  }
`;

export default PriceFilter;